<template>
  <!-- 立方体容器 -->
  <div class="bigcj-cubebox">
    <!-- 立方体 -->
    <div class="bigcj-cube bigcj-cube-ani">
      <!-- 立方体的六个面 -->
      <div class="forward"></div>
      <div class="back"></div>
      <div class="left"></div>
      <div class="right"></div>
      <div class="top"></div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
const viewId = 'DrawBox';
export default {
  name: viewId,
  data() {
    return {
      context: null,
    };
  },
  mounted() {
    
  },
  methods: {
    
  },
};
</script>

<style scoped>
/* 立方体容器样式 */
.bigcj-cubebox {
  position: absolute;
  top: 50%; /* 调整位置 */
  left: 50%; /* 调整位置 */
  transform: translate(-50%, -50%); /* 调整位置 */
  width: 156px; /* 调整大小 */
  height: 156px; /* 调整大小 */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* 立方体样式 */
.bigcj-cube {
  width: 156px; /* 调整大小 */
  height: 156px; /* 调整大小 */
  transform-style: preserve-3d;
  will-change: transform;
  transform: rotateY(-45deg) rotateZ(20deg) rotateX(-10deg);
}

/* 立方体动画样式 */
.bigcj-cube-ani {
  animation: bigcj-cube-ani 20s linear 0s infinite;
}

@keyframes bigcj-cube-ani {
  from {
    transform: rotateY(-45deg) rotateZ(20deg) rotateX(-10deg);
  }
  to {
    transform: rotateY(315deg) rotateZ(20deg) rotateX(-10deg);
  }
}

/* 立方体每个面的样式 */
.bigcj-cube div {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 0 30px #fff;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('@/assets/home/draw-icon.png');
}

/* 立方体各个面的具体位置样式 */
.bigcj-cube .forward {
  transform: translateZ(78px); /* 调整位置 */
}
.bigcj-cube .back {
  transform: translateZ(-78px) rotateY(180deg); /* 调整位置 */
}
.bigcj-cube .left {
  transform: rotateY(-90deg);
  left: -78px; /* 调整位置 */
}
.bigcj-cube .right {
  transform: rotateY(90deg);
  right: -78px; /* 调整位置 */
}
.bigcj-cube .top {
  transform: rotateX(90deg);
  top: -78px; /* 调整位置 */
}
.bigcj-cube .bottom {
  transform: rotateX(-90deg);
  bottom: -78px; /* 调整位置 */
}
</style>